import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__ from "../button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__ from "../combobox.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
function FilterField({ field, availableFields, actions, filterId }) {
    const [open, setOpen] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const [value, setValue] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)("");
    const inputRef = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)(null);
    const hasIcon = !!field.icon;
    const closePopover = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        setOpen(false);
    }, []);
    const handleFieldSelect = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((selectedField)=>{
        actions.removeFilter(filterId);
        actions.addFilter(selectedField, "", []);
        closePopover();
    }, [
        actions,
        filterId,
        closePopover
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.Combobox, {
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxTrigger, {
                asChild: true,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                    variant: "ghost",
                    className: "h-full group rounded-none rounded-l-lg px-2 font-normal hover:opacity-50 active:scale-100 text-[13px]",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
                        className: "flex items-center gap-1 whitespace-nowrap",
                        children: [
                            hasIcon && field.icon && /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].createElement(field.icon, {
                                className: "size-3.5 stroke-[2.25px]"
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                className: "text-foreground",
                                children: field.label
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxContent, {
                align: "start",
                className: "w-fit p-0",
                loop: true,
                filter: (value, search, keywords)=>{
                    const extendValue = `${value} ${keywords?.join(" ")}`;
                    return extendValue.toLowerCase().includes(search.toLowerCase()) ? 1 : 0;
                },
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxInput, {
                        value: value,
                        onValueChange: setValue,
                        ref: inputRef,
                        placeholder: "Search fields..."
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxEmpty, {
                        children: "No fields found"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxList, {
                        className: "max-h-fit",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxGroup, {
                            children: availableFields.map((availableField)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxItem, {
                                    value: availableField.id,
                                    keywords: [
                                        availableField.label
                                    ],
                                    onSelect: ()=>handleFieldSelect(availableField),
                                    className: "group",
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                        className: "flex w-full items-center gap-1.5",
                                        children: [
                                            availableField.icon && /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].createElement(availableField.icon, {
                                                strokeWidth: 2.25,
                                                className: "size-4"
                                            }),
                                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                                children: availableField.label
                                            })
                                        ]
                                    })
                                }, availableField.id))
                        })
                    })
                ]
            })
        ]
    });
}
export { FilterField };
